import { render, staticRenderFns } from "./DxDetailTabMachinary.vue?vue&type=template&id=d1254306&"
import script from "./DxDetailTabMachinary.vue?vue&type=script&lang=js&"
export * from "./DxDetailTabMachinary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports